import React from 'react'

const Card = ({image,title}) => {
  return (
    <div className='w-fit border border-gray-300 rounded-xl my-[10%]'>
        <div>
            <img className='rounded-t-xl' src={image} alt="" />
        </div>
        <div className='pt-5 pb-16 w-[90%]'>
            <p className='text-4xl text-[#03236F] font-medium font-sans text-center'>
                {title}
            </p>
        </div>
    </div>
  )
}

export default Card